// DS: i10.2
import React from 'react';
import IconWrap from '../IconWrap';
const Twitter = (props)=>/*#__PURE__*/ React.createElement(IconWrap, props, /*#__PURE__*/ React.createElement("svg", {
        width: "0",
        height: "0",
        viewBox: "0 0 24 24",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, /*#__PURE__*/ React.createElement("g", null, /*#__PURE__*/ React.createElement("path", {
        d: "M13.427 10.775L19.011 4h-1.323l-4.849 5.883L8.967 4H4.5l5.856 8.896L4.5 20h1.323l5.12-6.212L15.034 20H19.5l-6.073-9.225zm-1.812 2.199l-.594-.886-4.72-7.048h2.032l3.81 5.688.593.886 4.953 7.393h-2.033l-4.041-6.033z"
    }))));
Twitter.displayName = 'Twitter';
export default Twitter;

//# sourceMappingURL=Twitter.js.map